import { FunctionComponent } from 'react';
import './news.scss';

export type Props = {
  title: string;
  creationDate: string;
  description: string;
  link: string;
};

const NewsBox: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="news-box">
      <div className="news-box-top">
        <div className="news-box-title">{props.title}</div>
        <div className="news-box-date">{props.creationDate}</div>
        <div className="news-box-description">{props.description}</div>
      </div>
      <div className="news-box-link">
        <a href={props.link}>Weiterlesen</a>
      </div>
    </div>
  );
};

export default NewsBox;
